export const CUSTOMER_INFO = 'customerInfo';
export const FINGER_PRINT = 'fingerPrint';
export const STORE = 'store';
export const CUSTOMER_ID = 'CONFERWITH_CUSTOMER_ID';
